import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setEditId, selectBundleById } from "src/store/callrecorder/bundlesSlice";
import { fetchBundle } from "src/actions/callrecorder/bundlesActions";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "src/componets/SummaryShow";
import Products from "./_partials/_Products";
import Tabs from "src/componets/Tabs";
import Edit from "./Edit";
import { ButtonEdit } from "src/componets/Buttons";
import SidebarShow from "../Bundles/_partials/_SidebarShow";
import { fetchProducts } from "../../../actions/callrecorder/productsActions";
import UsersListTable from "../Users/_partials/_ListTable";
import Icon from "src/componets/Icon";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const bundle = useAppSelector(state => id ? selectBundleById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchBundle(id));
      dispatch(fetchProducts({ bundle_id: id }));
    }
  }, [id, dispatch]);

  const bundleFilterParams = useMemo(() => ({ bundle_id: id }), [id]);

  function onClickEdit() {
    if (bundle) {
      dispatch(setEditId(bundle.id));
    }
  }
  return (
    <PageLayout className='v-bundles-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            bundle &&
              <SummaryShow
                icon={<Icon icon="fa-brands fa-apple" />}
                title={bundle.name}
                createdAt={bundle.created_at}
                updatedAt={bundle.updated_at}
                actions={[
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />
                ]}
                className='v-mb-15'
              />
          }

          <Tabs
            paramsKey='tab'
            destroyInactiveTabPane={true}
            items={[
              { label: 'Products', key: 'products', children: <Products bundle={bundle} /> },
              { label: 'Users', key: 'users', children: <UsersListTable filterParams={bundleFilterParams} limit={25} /> },
            ]}
          />
        </div>
      </div>

      <Edit />

      <SidebarShow bundle={bundle} />
    </PageLayout>
  )
}

export default Show;
